import { create } from "zustand";

const useGenStore = create((set)=>({
   menuActive:false,

   setMenuActive:(st)=>set({menuActive:(st)}),
}))


export default useGenStore;